import React from 'react';

interface StoreSettingsProps {
  storeData: any;
  onUpdate: (data: any) => void;
}

const StoreSettings: React.FC<StoreSettingsProps> = ({ storeData, onUpdate }) => {
  return (
    <div style={{ color: 'white', padding: '40px', textAlign: 'center' }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px' }}>Store Settings</h1>
      <div style={{ 
        background: 'rgba(255,255,255,0.05)', 
        borderRadius: '16px', 
        padding: '30px',
        maxWidth: '600px',
        margin: '0 auto'
      }}>
        <h3 style={{ marginBottom: '20px' }}>Store Information</h3>
        <div style={{ textAlign: 'left', color: 'rgba(255,255,255,0.8)' }}>
          <p><strong>Name:</strong> {storeData.name}</p>
          <p><strong>Phone:</strong> {storeData.phone}</p>
          <p><strong>Address:</strong> {storeData.address}</p>
          <p><strong>Status:</strong> {storeData.isOpen ? '🟢 Open' : '🔴 Closed'}</p>
        </div>
        <p style={{ marginTop: '30px', color: 'rgba(255,255,255,0.6)' }}>
          ⚙️ Full settings management coming soon!
        </p>
      </div>
    </div>
  );
};

export default StoreSettings;
